import React, { useState, useEffect } from "react";

// Certificate PNG URLs (replace with your real PNG paths)
const certificates = [
  {
    id: "cert0",
    title: "Certificate of License ",
    url: "/pdfs/pdf0.png",
  },
  {
    id: "cert1",
    title: "Certificate of Incorporation ",
    url: "/pdfs/pdf1.png",
  },
  {
    id: "udyam-certificates",
    title: "UDYAM CERTIFICATES",
    certificates: [
      {
        id: "u0",
        title: "UDYAM CERTIFICATE PAGE 1",
        url: "/pdfs/u0.png",
      },
      {
        id: "u1",
        title: "UDYAM CERTIFICATE PAGE 2",
        url: "/pdfs/u1.png",
      },
      {
        id: "u2",
        title: "UDYAM CERTIFICATE PAGE 3",
        url: "/pdfs/u2.png",
      },
      {
        id: "u3",
        title: "UDYAM CERTIFICATE PAGE 4",
        url: "/pdfs/u3.png",
      },
 
    ],
  },
  {
    id: "cert3",
    title: "NGO DARPAN ID ( NITI AYOG )",
    url: "/pdfs/pdf4.png",
  },
];

// Simple error boundary for the Image Viewer
class ImgErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || "Unknown error" };
  }
  componentDidCatch(error, errorInfo) {}
  render() {
    if (this.state.hasError) {
      return (
        <div className="text-red-500 text-center font-bold p-4">
          Failed to load certificate image. <br />
          <span className="text-xs">{this.state.errorMsg}</span>
        </div>
      );
    }
    return this.props.children;
  }
}

const CertificationPage = () => {
  const [selected, setSelected] = useState(0);
  const [imgLoaded, setImgLoaded] = useState(false);
  const selectedCert = certificates[selected];

  // Preload images (for non-nested certs, and all UDYAM subcerts)
  useEffect(() => {
    certificates.forEach(cert => {
      if (cert.certificates) {
        cert.certificates.forEach(subcert => {
          const img = new window.Image();
          img.src = subcert.url;
        });
      } else if (cert.url) {
        const img = new window.Image();
        img.src = cert.url;
      }
    });
  }, []);

  // Reset imgLoaded state when selection changes
  useEffect(() => {
    setImgLoaded(false);
  }, [selected]);

  return (
    <div className="min-h-screen pt-32 flex flex-col items-center bg-[#FDF6EC] py-12 px-2">
      <h1 className="text-3xl md:text-5xl font-bold mb-6 text-[#E76F51]">
        Our Certifications
      </h1>
      <div className="mb-8 flex flex-wrap gap-4 justify-center w-full max-w-7xl">
        {certificates.map((cert, idx) => (
          <button
            key={cert.id}
            onClick={() => setSelected(idx)}
            aria-current={idx === selected ? "page" : undefined}
            className={`flex-1 min-w-[180px] max-w-xs px-4 py-2 rounded-lg font-semibold border transition ${
              idx === selected
                ? "bg-[#E76F51] text-white border-[#E76F51]"
                : "bg-white text-[#E76F51] border-[#E76F51] hover:bg-[#F4A261] hover:text-white"
            }`}
            aria-label={cert.title}
            style={{
              flexBasis: "calc(20% - 1rem)",
            }}
          >
            {cert.title}
          </button>
        ))}
      </div>

      <div
        className="bg-white rounded shadow-lg p-4 flex justify-center items-center"
        style={{ maxWidth: "800px", minHeight: "400px", width: "100%" }}
      >
        <ImgErrorBoundary>
          {
            // If selected cert is "UDYAM CERTIFICATES", show all 4 images in grid
            selectedCert.certificates ? (
              <div className="grid grid-cols-1 gap-4 w-full">
                {selectedCert.certificates.map((udhyamCert, i) => (
                  <div key={udhyamCert.id} className="flex flex-col items-center">
                    {!imgLoaded && i===0 && (
                      <span className="text-[#E76F51] mb-2">Loading certificate...</span>
                    )}
                    <img
                      src={udhyamCert.url}
                      alt={udhyamCert.title}
                      style={{
                        display: imgLoaded || i !== 0 ? "block" : "none",
                        borderRadius: "12px",
                        boxShadow: "0px 2px 16px rgba(0,0,0,0.05)",
                        objectFit: "contain",
                        maxHeight: "630px",
                        width: "100%",
                        background: "#FDF6EC",
                      }}
                      onLoad={() => {
                        if (i === 0) setImgLoaded(true);
                      }}
                      onError={() => {
                        if (i === 0) setImgLoaded(true);
                      }}
                      className="w-full"
                    />
                    <div className="mt-2 text-xs text-[#E76F51] font-semibold">{udhyamCert.title}</div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {!imgLoaded && (
                  <span className="text-[#E76F51]">Loading certificate...</span>
                )}
                <img
                  src={selectedCert.url}
                  alt={selectedCert.title}
                  style={{
                    display: imgLoaded ? "block" : "none",
                    borderRadius: "12px",
                    boxShadow: "0px 2px 16px rgba(0,0,0,0.05)",
                    objectFit: "contain",
                    maxHeight: "630px",
                    width: "100%",
                  }}
                  onLoad={() => setImgLoaded(true)}
                  onError={() => setImgLoaded(true)}
                />
              </>
            )
          }
        </ImgErrorBoundary>
      </div>
    </div>
  );
};

export default CertificationPage;